function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    cx: 22,
    cy: 22,
    r: 22,
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M20.25,33h3.89V23h3.24l.49-3.91H24.14v-2.5c0-1.13.3-1.9,1.87-1.9h2v-3.5A25.61,25.61,0,0,0,25.1,11c-2.88,0-4.85,1.82-4.85,5.17V19H17v4h3.25V33Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.00949e2fa1f9e5d1badfc9bf2fb33d37.svg";
export { ForwardRef as ReactComponent };